<nav>
    <div id="menu-icon" [routerLink]="['/home']">
        <mat-icon>home</mat-icon>
      </div>
    <ul id="nav-menu">
        <li class="nav-li" [routerLink]="['/projects']">Projects</li>
        <li class="nav-li" [routerLink]="['/skills']">Skills</li>
        <li class="nav-li" [routerLink]="['/about']">About</li>
    </ul>
</nav>